<template>
  <component :is="projectinterferingData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No projectinterfering found -->
    <b-alert variant="danger" :show="projectinterferingData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'projectinterfering-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab :projectinterfering-data="projectinterferingData" class="mt-2" />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "projectinterfering-add-new") {
      this.operationTitle = "Nouvelle Assertion";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "projectinterfering-view") {
      this.operationTitle = "Détails de l'projectinterfering";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "projectinterfering-edit") {
      this.operationTitle = "Modification de l'projectinterfering";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "projectinterfering-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let projectinterferingData = ref(null);

    var now = new Date();

    let APP_STORE_MODULE_NAME = "app-projectinterfering";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultprojectinterferingData = ref({
      type_folder: "",
      type_violence: "",
    });
    
    //
    if (router.currentRoute.name == "projectinterfering-add-new") {
      // init empty projectinterfering data
      projectinterferingData = defaultprojectinterferingData;
    }

    if (router.currentRoute.name != "projectinterfering-add-new") {
      // requirement
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          projectinterferingData.value = response.data;
        })
        .catch((error) => {
          projectinterferingData.value = undefined;
        });
    }

    return {
      projectinterferingData,
    };
  },
};
</script>
